import { ContentService } from '../services/ContentService'

export const useContent = () => {
  const alt = useAlt()

  return {
    get service() {
      return alt.get(ContentService)
    },
  }
}
